import { Button, ScreenContainer, ContentFrame, LayoutContent, LayoutControls, LayoutContentCenter, } from '@pinwheel/origami';
import React from 'react';
import { useParams } from 'react-router';
import CircledBangImage from '../../components/CircledBangImage';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import ModalHeader from '../../components/ModalHeader';
import { unstageDocument, selectStagedDocumentById, } from '../../state/slices/slice-document-uploads';
import { useAppDispatch, useAppSelector } from '../../state';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { ImageTitleLayout } from '../../components/ImageTitleLayout';
var DocumentUploadsDelete = function () {
    var getLocalizedString = useGetLocalizedString();
    var fileId = useParams().fileId;
    var dispatch = useAppDispatch();
    var navigate = useLinkNavigate();
    var toDelete = useAppSelector(function (state) {
        return selectStagedDocumentById(state, fileId);
    });
    var onCancelDelete = function () {
        navigate(-1);
    };
    var onDelete = function () {
        // Param types in react-router can be undefined, although this
        // should never happen in practice.
        if (fileId != null) {
            dispatch(unstageDocument(fileId));
        }
        navigate(-1);
    };
    return (React.createElement(ScreenContainer, { "data-testid": "DocumentUploads-delete" },
        React.createElement(ModalHeader, { title: toDelete === null || toDelete === void 0 ? void 0 : toDelete.name, clampTitleText: true }),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement(LayoutContentCenter, { "data-testid": "DocumentUploads-delete" },
                    React.createElement(ImageTitleLayout, { title: getLocalizedString('DELETE_DOCUMENT'), subtitle: getLocalizedString('DELETE_DOCUMENT_EXPLAINER') },
                        React.createElement(CircledBangImage, null)))),
            React.createElement(LayoutControls, null,
                React.createElement(Button, { variant: "outline", eventId: "cancel-delete", dataTestId: "button", onClick: onCancelDelete }, getLocalizedString('CANCEL')),
                React.createElement(Button, { eventId: "delete", dataTestId: "button", onClick: onDelete }, getLocalizedString('DELETE'))))));
};
export default DocumentUploadsDelete;
